import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Modal, Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { CommonFormProps, OnboardingLayout } from '.';
import { BackButton, CountryInput, Form } from '~/components';
import { createPath } from '~/pages/onboarding/Sider';
import { useOnboardingPage, useOnboardingState, useResetOnboardingState } from '~/hooks/onboarding';

const { Title, Text } = Typography;

const Country: FC<CommonFormProps> = (props) => {
  const { name } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [form] = Form.useForm();
  const onboardingPage = useOnboardingPage(name);

  const [pageState, setPageState] = useOnboardingState(name);
  const resetOnboardingState = useResetOnboardingState();

  const onFinish = (values: any) => {
    const prevCountry = pageState.formData?.country;
    if (prevCountry) {
      Modal.confirm({
        title: t('startFromBegining'),
        icon: <ExclamationCircleOutlined />,
        content: t('changesWillLost'),
        okText: dt('confirm'),
        cancelText: dt('cancel'),
        onOk() {
          resetOnboardingState();
          onboardingPage.goFirst();
        },
      });
    } else {
      setPageState((prev) => ({
        ...prev,
        formData: values,
      }));
      onboardingPage.activateNext();
      onboardingPage.goNext();
    }
  };

  return (
    <OnboardingLayout>
      {pageState.skip && <Redirect to={createPath('personalInfo')} />}
      <Title level={2}>{t('countryHeader')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('countrySubtitle')}</Text>
        <Form
          form={form}
          name={name}
          initialValues={pageState.formData || undefined}
          layout="vertical"
          size="large"
          onFinish={onFinish}
        >
          <Form.Item name="country" rules={[{ required: true }]}>
            <CountryInput placeholder={t('countryInputPlaceholder')} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <BackButton onClick={onboardingPage.goBackToVisible} />
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit">
                  {dt('continue')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default Country;
